<template>
  <div id="cliente-main" transition="slide-x-transition">
    <!-- TODO: revisar recomendador -->
    <!-- <cliente-recomendados/> -->
    <cliente-compras/>
    <cliente-wish-list/>
    <cliente-likes/>
    <cliente-historial/>
  </div>
</template>
<script>
import ClienteCompras from './ClienteCompras.vue'
import ClienteHistorial from './ClienteHistorial.vue'
import ClienteLikes from './ClienteLikes.vue'
import ClienteRecomendados from './ClienteRecomendados.vue'
import ClienteWishList from './ClienteWishList.vue'

export default {
  components: { ClienteRecomendados, ClienteCompras, ClienteWishList, ClienteLikes, ClienteHistorial },
  name: 'clienteMain',
  data() {
    return {
      
    }
  },
  methods: {
    
  },
}
</script>